<script setup>
import { ref, computed, onMounted } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { useStore } from 'vuex'
import { supabase } from '@/supabase'

import Button from 'primevue/button'
import ProgressBar from 'primevue/progressbar'
import Card from 'primevue/card'
import Tag from 'primevue/tag'
import Dialog from 'primevue/dialog'



const router = useRouter()
const route = useRoute()
const store = useStore()
const loading = computed(() => store.state.loading)
const disciplina = computed(() => store.state.aula.disciplina)
const idDisciplina = computed(() => store.state.aula.idDisciplina)
const idDaAula = computed(() => store.state.aula.idDaAula)
const aulas = ref([])
const aulasCarregadas = ref(false)
const visible = ref(false)

onMounted(() => {
    if (disciplina.value == null || idDaAula.value == null) {
        goBack()
    }
    listarAulas()

})
function goBack() {
    router.push({ path: '/estudante/' })
}

async function listarAulas() {
    store.dispatch('updateLoading', true)
    const { data, error } = await supabase
        .from('planos')
        .select(`id, titulo, linkComOrientacoes, trimestre, planos_aulas!inner(id, plano, aula, visivelParaOEstudante )`)
        .eq('planos_aulas.aula', idDaAula.value)
        .not('planos_aulas.aula', 'is', null)
        .order('created_at', { ascending: false })

    aulas.value = data
    aulasCarregadas.value = true
    store.dispatch('updateLoading', false)
}

const verAula = (idPlano, tituloPlano) => {
    let data = {
        idDaAula: idDaAula.value,
        disciplina: disciplina.value,
        tituloPlano: tituloPlano,
        idPlano: idPlano,
        idDisciplina: idDisciplina.value
    }
    store.dispatch('updateAula', data)
    router.push({
        path: '/estudante/aula/conteudo'
    });
};

function verCaderno() {
    router.push({ path: '/estudante/caderno' })
}

</script>

<template>
    <div>
        <ProgressBar v-if="loading" mode="indeterminate" style="height: 3px" class="z-5 progress-bar"></ProgressBar>
        <div class="header border-bottom-1 border-200 z-3">
            <div class="text-color text-xl flex align-items-center">
                <Button @click="goBack" icon="pi pi-arrow-left" text rounded aria-label="Filter" severity="secondary" />
                <span class="ml-2">{{ disciplina }}</span>
            </div>
            <Button class="hidden" icon="pi pi-book" @click="verCaderno" label="Caderno" aria-label="Save" severity="secondary" text />
        </div>
        <div class="p-3 pt-8">
            <div class="container flex gap-3 flex-column fadein animation-duration-500">
                <div class=" justify-content-end hidden">
                    <Button icon="pi pi-chart-bar" label="Ver Meu Progresso" class="w-50rem" outlined rounded
                        @click="visible = true" />
                </div>

                <div v-if="aulas.length == 0 && aulasCarregadas == true">

                    <div class="text-center">O professor ainda não postou nenhuma aula para que você possa ver.</div>
                </div>


                <div v-for="aula in aulas" :key="aula.id">
                    <div @click="verAula(aula.id, aula.titulo)"
                        class="card h-full shadow-1 hover:shadow-3 animation-duration-1000 cursor-pointer p-3 py-5 md:p-5 bg-white border-round-md">
                        <div class="flex align-items-center gap-3 ">
                            <div class="pi pi-box text-2xl text-color-secondary"></div>
                            <div class="flex align-items-center justify-content-between w-full">
                                <div class="font-semibold text-color text-lg md:text-xl">{{ aula.titulo }}</div>
                                <Tag class="tag-aulas" :value="`${aula.trimestre}° tri`" rounded></Tag>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>

        <Dialog v-model:visible="visible" modal header="Header" :style="{ width: '50rem' }"
            :breakpoints="{ '1199px': '75vw', '575px': '90vw' }">


        </Dialog>

    </div>
</template>
<style>span.p-tag.p-component.p-tag-rounded.tag-aulas {
    min-width: 55px;
}</style>